import { Injectable } from '@angular/core';
import {HttpClient, HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs";
import {Allegato} from "../models/integrazione";

@Injectable({
  providedIn: 'root'
})
export class TributiService {
  url: string;
  constructor(private httpClient: HttpClient) {
    this.url = "services/portaletributi/api";
  }

  tributi(cdServizio: any): Observable<HttpResponse<any>>{
    return this.httpClient.get<any>(this.url + "/servizio/tributi?cdServizio=" + String(cdServizio.cdServizio), { observe: 'response' })
  }

  richiestaInizialeIstanza(istanzaDaRichiedere: any): Observable<any>{
    return this.httpClient.get<any>(this.url + '/istanza/richiestaInizialeIstanza', istanzaDaRichiedere)
  }

  getIntegrazione(idIstanza: string): Observable<any>{
    return this.httpClient.get<any>(this.url + `/getIntegrazione?idIstanza=${idIstanza}`)
  }

  integraIstanza(idIntegrazione: number, listaAllegati: Array<Allegato> ): Observable<any>{
    return this.httpClient.post(this.url + `/integraAllegatiPagamenti?idIntegrazione=${idIntegrazione}`, listaAllegati , {observe: "response", responseType: 'text'});
  }

  integraPagamento(idIntegrazione: number, idPagamento: number):Observable<any>{
    return this.httpClient.post(this.url + `/integraAllegatiPagamenti?idIntegrazione=${idIntegrazione}&idIstanzaPagamento=${idPagamento}`, null, {observe: "response", responseType: 'text'})
  }
}
